import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MainContent from './components/MainContent';
import AboutPage from './components/AboutPage';
import Page from './components/Page';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import NotFound from './components/NotFound';
import MetaverseShop from './metaverse/MetaverseShop';
import './scss/App.scss';

const CustomCursor = () => {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!mq.matches) return;
    setVisible(true);

    const move = (e) => setPos({ x: e.clientX, y: e.clientY });
    const selectors = 'a, button, .gc-product-card, .gc-slider__dot';
    const over = (e) => {
      if (e.target.closest(selectors)) setHovering(true);
    };
    const out = (e) => {
      const target = e.target.closest(selectors);
      if (target && (!e.relatedTarget || !target.contains(e.relatedTarget))) {
        setHovering(false);
      }
    };

    window.addEventListener('mousemove', move, { passive: true });
    document.addEventListener('mouseover', over);
    document.addEventListener('mouseout', out);
    return () => {
      window.removeEventListener('mousemove', move);
      document.removeEventListener('mouseover', over);
      document.removeEventListener('mouseout', out);
    };
  }, []);

  if (!visible) return null;
  return (
    <div
      className={`gc-cursor${hovering ? ' gc-cursor--hover' : ''}`}
      style={{ left: pos.x, top: pos.y }}
    />
  );
};

// ルートに応じてレイアウトを切り替える（"/" はフルスクリーン3D店舗）
const Shell = () => {
  const { pathname } = useLocation();
  const immersive = pathname === '/';

  if (immersive) {
    return (
      <Routes>
        <Route path="/" element={<MetaverseShop />} />
      </Routes>
    );
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <Routes>
        <Route path="/classic" element={<MainContent />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/pages/:slug" element={<Page />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
};

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <BrowserRouter>
      <div className={`gc-loading${loaded ? ' gc-loading--done' : ''}`}>
        <div className="gc-loading__content">
          <span className="gc-loading__logo">Guri Coffee</span>
          <span className="gc-loading__line" />
          <span className="gc-loading__tagline">人生の余白時間を、コーヒーとともに。</span>
        </div>
      </div>
      <CustomCursor />
      <Shell />
    </BrowserRouter>
  );
}

export default App;
